module.exports = __webpack_public_path__ + "/img/Snap-Lock-OSmytI.svg";